const apiUrls = {
  getAdminSections: '/AccountStatement/Api/v1/AdminSectionsElements/GetAdminSections',
  register: '/AccountStatement/Api/v1/AdminSectionsElements',
  validateDinamicElements: '/AccountStatement/Api/v1/Statements/ExistsStatements',
};

export default apiUrls;
